import { render, staticRenderFns } from "./compareDiagram.vue?vue&type=template&id=3c850254&scoped=true&"
import script from "./compareDiagram.vue?vue&type=script&lang=js&"
export * from "./compareDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c850254",
  null
  
)

export default component.exports